const emailMessage = {
    EMAIL_ADDRESS_SEPERATOR : ';'

};

angular.module('gw-um-j2js')
    .constant('emailMessage', emailMessage);